/** The id of the element SheetNav renders for footer controls, left of its tabs. */
export const SHEET_NAV_TOOLBAR_ID = 'sheetnav-toolbar'

/**
 * Teleport target for footer controls rendered anywhere on the page: `<Teleport :to="SHEET_NAV_TOOLBAR_SELECTOR">`.
 * @public
 */
export const SHEET_NAV_TOOLBAR_SELECTOR = `#${SHEET_NAV_TOOLBAR_ID}`
